import {HttpStatusCode} from 'axios';

/** Max attempts (initial call + refresh/WAF retries) before `reAuth` gives up. */
export const MAX_RETRIES = 3;

/** Delay before retrying a request that hit a WAF challenge. */
export const WAF_RETRY_DELAY_MS = 1000;

/** RTK Query / fetchBaseQuery error shape so callers never get undefined. */
export const sessionExpiredResult = {
  error: {
    status: HttpStatusCode.Unauthorized,
    data: {message: 'Session expired'},
  },
};
